import { SbtiRecord } from '@upright/common/model/company-client-data/sbti/types';
import {
  ClientDatumRelevance,
  ClientDatumSource,
  CompanyClientDataType,
} from '@upright/common/model/company-client-data/types';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';

export interface ImpactTarget {
  text: string;
  impactCategoryId: ImpactCategoryId;
  valence: Valence;
  companyId: string;
  id: number;
  clientDataType: CompanyClientDataType;
  likes?: number;
  liked?: boolean;
  relevance?: ClientDatumRelevance; // TODO: Once we clean this, change to mandatory
  link?: string;
  sourceName?: string;
  sourceLink?: string;
  sourceType?: ClientDatumSource;
  order?: number;
}

export interface SbtiTarget extends SbtiRecord {
  clientDataType: CompanySBTIDataType.SBTI_TARGET;
  impactCategoryId: ImpactCategoryId;
  valence: Valence;
  text: string | null; // RN: Added because TargetsInfoBoxes adds keys based on text property. Remove if fixed to use id's for keys.
  order: number;
}

export enum CompanySBTIDataType {
  SBTI_TARGET = 'science-based-target',
}

export type ImpactTargetOrSbtiTarget = ImpactTarget | SbtiTarget;
